import {customElement, inject, PLATFORM, DOM} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';
import {CustomerService} from '../../../services/customer-service';

@inject(DOM.Element, I18N, CustomerService)
@customElement('access-menu-smd')
export class AccessMenuSmd {
  buttonEl;
  visible = false;
  popUpError: boolean;
  data: any;

  constructor(public el: Element, public i18n: I18N, cs: CustomerService) {
    this.el = el;
    this.i18n = i18n;
    this.popUpError = false;
    if (cs.customHost()) {
      this.data = [
        {
          icon: 'ic_help',
          label: this.i18n.tr('head.menu.help'),
          click: e => this.openHelp()
        }
      ];
    } else {
      this.data = [
        {
          icon: 'ic_help',
          label: this.i18n.tr('head.menu.help'),
          click: e => this.openHelp()
        }, {
          icon: 'ic_home',
          label: this.i18n.tr('head.menu.home'),
          click: e => this.goHome()
        }
      ];
    }
  }
  openHelp() {
    let helpWin = PLATFORM.global.open('http://86borders.zendesk.com', '_blank');
    try {
      helpWin.focus();
    }    catch (e) {
      this.visible = false;
      this.popUpError = true;
    }
  }

  goHome() {
    let language = this.i18n.getLocale();
    //PLATFORM.location.replace("/?language="+language);
    let homeWin = PLATFORM.global.open('/?language=' + language, '_blank');
    try {
      homeWin.focus();
    }    catch (e) {
      this.visible = false;
      this.popUpError = true;
    }
  }

}

